import { apiGet } from "@redriver/cinnamon";

const NAMESPACE = "SYSTEM/WORKSPACE_SEARCH";

export const ActionTypes = {
  SearchWorkspace: `${NAMESPACE}/SEARCH`,
};

export const searchWorkspace = ({ term, maxResultsPerGroup = 5, siteId }) =>
  apiGet(ActionTypes.SearchWorkspace, "workspace/search", {
    term,
    maxResultsPerGroup,
    siteId,
  });
